import { BiValueAxisStyle, BiVizStyle } from '@euler/model/bi/viz';

function rangeProblem(name: string, axis: BiValueAxisStyle | undefined) {
  if (axis?.min === undefined || axis.max === undefined) return null;
  return axis.min < axis.max ? null : `${name}的最小值要小于最大值`;
}

/** Why the look cannot be saved as set, or null. */
export function biStyleProblem(style: BiVizStyle | undefined): string | null {
  return (
    rangeProblem('纵轴', style?.axes?.y) ??
    rangeProblem('右轴', style?.axes?.y2)
  );
}
